/**
 * App — top-level component.
 *
 * Responsibilities:
 *   - Restores the session on a cold start, before the router can decide the
 *     visitor is signed out
 *   - Activates the inactivity logout hook globally
 *   - Mounts the router (which renders pages based on URL)
 *
 * Any other "always-on" global behavior (e.g., global toast manager,
 * error boundary) should be added here.
 */

import AppRouter from '@/routes/AppRouter';
import PwaUpdatePrompt from '@/components/PwaUpdatePrompt';
import { useInactivityLogout } from '@/hooks/useInactivityLogout';
import { useSessionRestore } from '@/hooks/useSessionRestore';
import SplashScreen from '@/components/SplashScreen';

export function App() {
  // Ask the httpOnly refresh cookie whether this is still a live session. The
  // router must not run until we know, or a reload flashes the login screen.
  const ready = useSessionRestore();

  // Auto-logout after inactivity (only active when user is authenticated).
  useInactivityLogout();

  if (!ready) return <SplashScreen />;

  return (
    <>
      <AppRouter />
      <PwaUpdatePrompt />
    </>
  );
}

export default App;
